var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"terms-section"},[(_vm.consentForm)?_c('iframe',{attrs:{"src":_vm.consentForm,"frameborder":"0"}}):_c('div',[_vm._v("Termo não encontrado")])])
}
var staticRenderFns = []

export { render, staticRenderFns }